export default __webpack_public_path__ + "static/media/gov-mg-brand.3d90fc7a.svg";